import { useTranslation } from 'react-i18next';
import LanguageSwitcher from '../LanguageSwitcher';

function HomepageImage() {
    const { t } = useTranslation();

    return ( 
        <div className="relative hidden md:block">
            <div className="parallax-container min-h-[600px] relative">
                <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/30 to-black/30 w-full h-full">
                    <div className="absolute inset-0 bg-black/30"></div>
                    <div className="flex items-center justify-center h-full relative z-10">
                        <div className="text-center max-w-4xl mx-auto px-4">
                            <h1 className="text-5xl font-bold mb-6 text-[#ffffff]">{t('giveBooksNewLife')}</h1>
                            <p className="text-2xl text-[#ffffff] leading-relaxed">
                                {t('missionStatement')}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default HomepageImage;